import * as React from "react";
import { Dialog as DialogPrimitive } from "radix-ui";

const NAME = "DialogPortal";

export type DialogPortalProps = DialogPrimitive.DialogPortalProps;

export const DialogPortal = ({
  forceMount = true,
  ...props
}: DialogPortalProps) => (
  <DialogPrimitive.Portal forceMount={forceMount} {...props} />
);

DialogPortal.displayName = NAME;
